<app-accordion 
  *ngFor="let item of reports" 
  [title]="item.title" 
  [items]="item.items" 
  [isOpen]="item.isOpen"
  (favoriteToggled)="onFavoriteToggled($event)"
></app-accordion>